export default "__VITE_ASSET__54933f81__"